const CheckInMapEventType = {
	MAP_LOADED: 'mapLoaded',
	PAGE_WITH_MAP_LOADED: 'pageWithMapLoaded',
	MARKER_CLICKED: 'markerClicked',
	CLUSTER_CLICKED: 'clusterClicked',
};

export default CheckInMapEventType;
